export const arrays = {
  TipoPessoa: [
    { value: 1, text: 'Pessoa Física' },
    { value: 2, text: 'Pessoa Jurídica' }
  ],
  SchemaGridRelatorios: [
    { text: 'Ação', value: 'acao' },
    { text: 'Definição', value: 'definicao' }
  ],
  ItemsGridRelatorios: [
    {
      acao: 'Requisitar Arquivo',
      definicao:
        'Após selecionar o filtro, o arquivo é colocado numa fila para ser processado e montado'
    },
    {
      acao: 'Download',
      definicao:
        'Com a chave enviado por email, você pode fazer download do arquivo requisitado'
    }
  ]
};
